<template lang="pug">
.v-news-card.news-card(v-if="card" @mouseenter="open = true" @mouseleave="open = false")
	img.news-card__bg(v-if="card.image" :src="card.image.src" alt="card.image.alt")
	.news-card__content
		.news-card__sticker(v-if="card.category || card.date")
			span.news-card__category {{card.category}}
			span.news-card__date {{card.date}}
		.news-card__body
			.news-card__title(v-if="card.title") {{card.title}}
			v-collapse(v-if="card.text || isTablet" :open="open || isTablet")
				.news-card__text
					span.news-card__text-inner {{card.text}}
	a.cover-link(v-if="card.link" :href="card.link") {{card.title}}
</template>

<script>
import isMobMixin from "components/mixins/v-mixin-is-mob.vue";

export default {
	mixins: [
		isMobMixin
	],

	props: {
		card: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			open: false
		}
	}
}

</script>